var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOrderBookSortAskBid = function SvgOrderBookSortAskBid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4h7v7H4V4z",
    fill: "#F93A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13h7v7H4v-7z",
    fill: "#10C36D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4h7v4h-7V4zm0 6h7v4h-7v-4zm7 6h-7v4h7v-4z",
    fill: "#FFFFFF"
  })));
};
export default SvgOrderBookSortAskBid;